<template>
    <div class="saved-reports" style="max-width: 100%;">
        <div class="save-chart title mt-3">
            <span class="pl-2">Value Players</span>
            <span class="align-middle ml-1" v-if="isDashboardView">
                <modal-link modal-id="Value Players" :content-list="pageContentForDashboard"></modal-link>
            </span>
        </div>
        <div class="mt-5">
            <div class="d-flex justify-content-center align-items-center">

                <label class="d-flex align-items-center align-middle mr-3 pt-1">
                    <input type="radio" class="align-middle mr-1" name="labelMode" value="actions" v-model="labelMode">
                    <span class="align-middle">Show Actions</span>
                </label>

                <label class="d-flex align-items-center align-middle mr-3 pt-1">
                    <input type="radio" class="align-middle mr-1" name="labelMode" value="needs" v-model="labelMode">
                    <span class="align-middle">Show Needs</span>
                </label>

                <label class="d-flex align-items-center align-middle mr-3 pt-1">
                    <input type="radio" class="align-middle mr-1" name="labelMode" value="metrics" v-model="labelMode">
                    <span class="align-middle">Show Metrics</span>
                </label>

                <label class="d-flex align-items-center align-middle mr-3 pt-1">
                    <input type="radio" class="align-middle mr-1" name="labelMode" value="moats" v-model="labelMode">
                    <span class="align-middle">Show Moats</span>
                </label>

                <label class="d-flex align-items-center align-middle ml-5 pt-1">
                    <input type="checkbox" class="align-middle mr-1" v-model="showTraffic">
                    <span class="align-middle">Show Traffic Lights</span>
                </label>

            </div>

            <div ref="chartEl" class="chart"></div>
        </div>
    </div>
</template>

<script>
import DashboardMixins from "../mixins/DashboardMixins.vue";
import ViewMixins from "../mixins/ViewMixins.vue";
import AdminMixins from "../mixins/AdminMixins.vue";
import AdminService from "../services/admin.service";
import ValuePlayerService from "../services/value.player.service";
import NeedQuestionService from "../services/need.question.service";
import echarts from "echarts/lib/echarts";
import "echarts/lib/chart/custom";
import "echarts/lib/chart/lines";
import "echarts/lib/chart/graph";
import "echarts/lib/component/grid";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/graphic";

export default {
    name: "DashboardValuePlayers",
    mixins: [AdminMixins, ViewMixins, DashboardMixins],
    components: {},
    data() {
        return {
            chart: null,
            showTraffic: true,
            node_coords: [
                { id: "1", x: 17, y: 60 },
                { id: "2", x: 30, y: 38 },
                { id: "3", x: 75, y: 38 },
                { id: "4", x: 70, y: 86 },
                { id: "5", x: 45, y: 60 },
                { id: "6", x: 30, y: 86 },
                { id: "7", x: 50, y: 86 },
                { id: "8", x: 55, y: 38 },
                { id: "9", x: 83, y: 60 }
            ],
            // NEW: dotted lines coordinates (hard-coded 11)
            dottedLines: [
                { id: '1', startX: 41, startY: 60, endX: 21, endY: 60 },
                { id: '2', startX: 41, startY: 60, endX: 32, endY: 44 },
                { id: '3', startX: 71, startY: 38, endX: 59, endY: 38 },
                { id: '4', startX: 71, startY: 79, endX: 75, endY: 45 },
                { id: '5', startX: 46, startY: 85, endX: 43, endY: 66 },
                { id: '6', startX: 41, startY: 60, endX: 32, endY: 80 },
                { id: '7', startX: 71, startY: 79, endX: 49, endY: 62 },
                { id: '8', startX: 46, startY: 85, endX: 48, endY: 64 },
                { id: '9', startX: 51, startY: 38, endX: 34, endY: 38 },
                { id: '10', startX: 53, startY: 44, endX: 47, endY: 54 },
                { id: '11', startX: 71, startY: 79, endX: 81, endY: 66 },
            ],
            moat_display_options: {
                "pioneer-moats": ["Brand Perception", "Upstart Power", "Channel Lock-Out"],
                "core-moats": ["Value Chain", "Design Dominance"],
                "rocket-moats": ["Routine Reliance", "Economies of Skill", "Economies of Scale", "Switching Lock-In", "Network Effect", "Time Multiplier"]
            },
            //playerNodes: [],
            connectors: [],
            //surveyId: 41822,
            //clientTimePeriodId: 23559,
            functionalNeedsList: [],
            //emotionalNeedsList: ["Trust", "Adaptability", "Activity", "Creativity", "Assurance"],
            emotionalNeedsList: [],
            labelMode: "actions", // 'actions' | 'metrics' | 'needs' | 'moats'
            saved_metric_options: [],
            metrics: [],
            signals: [],
            includeValuePlayers: false,
        };
    },
    props: {
        surveyId: {
            type: Number,
            default: 0
        },
        entrySurveyCode: {
            type: String,
            default: ""
        },
        entrySurveyName: {
            type: String,
            default: ""
        },
        viewType: {
            type: String,
            default: "standard"
        },
        entryClientObject: {
            type: Object,
            default: function () {
                return {};
            }
        },
        pageContentForDashboard: {
            type: Array,
            default: function () {
                return [];
            },
        },
        clientTimePeriodId: {
            type: String,
            default: ""
        },
        playerNodes: {
            type: Array,
            default: function () {
                return [];
            },
        }
    },
    computed: {
        isDashboardView: function () {
            return this.viewType == "dashboard"
        },
        showActions() {
            return this.labelMode === "actions";
        },
        showMetrics() {
            return this.labelMode === "metrics";
        },
        showMoats() {
            return this.labelMode === "moats";
        },
        showNeeds() {
            return this.labelMode === "needs";
        },
    },
    created() {
        this.fetchValuePlayerNodesData();
    },
    mounted() {
        this.chart = echarts.init(this.$refs.chartEl);
        this.render();
    },
    beforeUnmount() {
        if (this.chart) this.chart.dispose();
    },
    watch: {
        showTraffic() {
            this.render();
        },
        labelMode() {
            this.render();
        },
        clientTimePeriodId: {
            handler() {
                this.render();   // rebuild chart based on new filter
            },
            immediate: false
        }
    },
    methods: {
        async fetchValuePlayerNodesData() {
            await NeedQuestionService.getNeedQuestionMetrics(this.surveyId, this.getNeedQuestionMetricsCallback, this);
            await ValuePlayerService.getValuePlayerSignalMapping(this.surveyId, Number(this.clientTimePeriodId), this.getValuePlayerSignalMappingCallback, this);
            await ValuePlayerService.getValuePlayerChartAttributes(this.surveyId, this.getValuePlayerChartAttributesCallback, this);
            await ValuePlayerService.getValuePlayerMappingData(this.surveyId, this.getValuePlayerMappingDataCallback, this);
        },
        getValuePlayerChartAttributesCallback(response) {
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                let functionalNeedsList = response.data.data.functional;
                functionalNeedsList = functionalNeedsList.map(conn => {
                    const match = (this.signals || []).find(
                        met => String(met.questionId) === String(conn.questionId)
                    );
                    return {
                        ...conn,
                        signalColor: match?.signalColor || "",
                    };
                });

                // Track where each moatName was first seen
                const seen = new Map();

                for (let i = 0; i < functionalNeedsList.length; i++) {
                    const curr = functionalNeedsList[i];
                    const key = curr.moatName;

                    if (!seen.has(key)) {

                        // First occurrence → normalize fields to arrays
                        curr.needName = curr.needName ? [curr.needName] : [];
                        curr.signalColor = curr.signalColor ? [curr.signalColor] : [];
                        seen.set(key, curr);

                    } else {

                        // Already seen → merge into first record
                        const first = seen.get(key);

                        // Prevent duplicate NEEDS text (still required)
                        if (curr.needName && !first.needName.includes(curr.needName)) {
                            first.needName.push(curr.needName);
                        }

                        // Allow duplicate TRAFFIC SIGNAL entries (required change)
                        if (curr.signalColor) {
                            first.signalColor.push(curr.signalColor); // <-- No includes() check now
                        }

                        // Remove the duplicate row from the source list
                        functionalNeedsList.splice(i, 1);
                        i--;
                    }
                }

                // save back to original variable (still same reference)
                this.functionalNeedsList = functionalNeedsList;
                this.emotionalNeedsList = this.signals.filter(s => (s.needType || "").trim().toLowerCase() === "emotional");
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        getValuePlayerMappingDataCallback(response) {
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                this.connectors = response.data.data.map(m => ({
                    id: String(m.lineNumber),
                    src: String(m.sourceValuePlayerNodeId),
                    dst: String(m.targetValuePlayerNodeId),
                    action: m.actionText || "",
                    questionId: m.questionId
                }));

                // merge with metricName from metrics where ids match
                this.connectors = this.connectors.map(conn => {
                    const match = (this.metrics || []).find(
                        met => String(met.questionId) === String(conn.questionId)
                    );
                    return {
                        ...conn,
                        metricName: match?.metricName || []
                    };
                });

                this.connectors = this.connectors.map(conn => {
                    const match = (this.functionalNeedsList || []).find(
                        met => String(met.questionId) === String(conn.questionId)
                    );
                    return {
                        ...conn,
                        moatName: match?.moatName || "",
                        needName: match?.needName || [],
                        signalColor: match?.signalColor || []
                    };
                });

                // re-render after data arrives
                this.$nextTick(() => {
                    if (this.chart) this.render();
                });
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        getNeedQuestionMetricsCallback(response) {
            this.metric_options = [];
            this.metricId = "";
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                this.saved_metric_options = response.data.data.savedOptions;
                // Group by questionId and collect all metric names
                const grouped = Object.values(
                    this.saved_metric_options.reduce((acc, cur) => {
                        if (!acc[cur.questionId]) {
                            acc[cur.questionId] = {
                                questionId: cur.questionId,
                                needQuestionId: cur.needQuestionId,
                                metricName: []
                            };
                        }
                        acc[cur.questionId].metricName.push(cur.name);
                        return acc;
                    }, {})
                );
                this.metrics = grouped;
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        getValuePlayerSignalMappingCallback(response) {
            let statusCode = response.data.statusCode;
            if (statusCode == 200) {
                this.signals = response.data.data;
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
            }
        },
        postLoadData: function () {
            this.setDisplayView(true);
            this.displayQuestions = true;
        },
        getMergedPlayers() {
            return this.playerNodes
                .filter(p => p.label && p.label.trim() !== "") // exclude blank names
                .map(p => ({
                    ...p,
                    ...(this.node_coords.find(c => c.id === p.id) || {})
                }));
        },
        getMergedLinks() {
            return (this.connectors || [])
                .filter(c => c && c.src && c.dst)
                .map(c => [
                    c.src,
                    c.dst,
                    c.action || "",
                    c.signalColor || [],
                    c.metricName || [],
                    c.moatName || "",
                    c.needName || []
                ]);
        },
        playerById(id) {
            return this.getMergedPlayers().find(n => n.id === id);
        },

        buildOption() {
            const mergedPlayers = this.getMergedPlayers();
            const playerMap = new Map(
                mergedPlayers.map(p => [String(p.id), p])
            );
            // Enrich connectors with srcNode/dstNode and filter out broken ones
            const mergedLinks = (this.connectors || [])
                .filter(c => c && c.src && c.dst)
                .map(c => {
                    const srcNode = playerMap.get(String(c.src));
                    const dstNode = playerMap.get(String(c.dst));
                    if (!srcNode || !dstNode) return null;   // drop if node missing

                    return {
                        id: String(c.id),
                        src: String(c.src),
                        dst: String(c.dst),
                        action: c.action || "",
                        status: c.signal || "",
                        metricName: c.metricName || [],
                        moatName: c.moatName || "",
                        needName: c.needName || [],
                        signalColor: c.signalColor || []
                    };
                })
                .filter(Boolean);

            // Merge dottedLines geometry with *mergedLinks* metadata (by id)
            const dottedEdges = (this.dottedLines || [])
                .map(seg => {
                    // match connector where connector.id == dottedLines.id
                    const match = mergedLinks.find(c => c.id === String(seg.id));
                    if (!match) return null;   // no connector => no dotted line

                    return {
                        id: seg.id,
                        startX: seg.startX,
                        startY: seg.startY,
                        endX: seg.endX,
                        endY: seg.endY,
                        action: match.action || "",
                        status: match.signal || "",
                        metricName: match.metricName || [],
                        moatName: match.moatName || "",
                        needName: match.needName || [],
                        signalColor: match.signalColor || []
                    };
                })
                .filter(Boolean);

            function getDottedMidpoint(api, seg, sideOffset = 0, verticalOffset = 0) {
                const p1 = api.coord([seg.startX, seg.startY]);
                const p2 = api.coord([seg.endX, seg.endY]);

                const mx = (p1[0] + p2[0]) / 2;
                const my = (p1[1] + p2[1]) / 2;

                const dx = p2[0] - p1[0];
                const dy = p2[1] - p1[1];
                const L = Math.hypot(dx, dy) || 1;

                let nx = -dy / L;
                let ny = dx / L;

                // FIX: If the line is horizontal (dy ≈ 0), force normal to behave as a left/right shift
                if (Math.abs(dy) < 1) {
                    nx = dx > 0 ? 1 : -1;  // direction based on line orientation
                    ny = 0;                // no vertical movement
                }

                return [
                    mx + nx * sideOffset,
                    my + ny * sideOffset + verticalOffset
                ];
            }

            // ---------------- INVERTED TRAPEZOID (top narrow, bottom wide) ----------------
            const basePlate = {
                name: "TrapezoidBase",
                type: "custom",
                coordinateSystem: "cartesian2d",
                encode: { x: 0, y: 1 },
                silent: true,
                z: 0,
                renderItem: (params, api) => {
                    try {
                        // Top narrower, bottom wider
                        const topY = 25,
                            botY = 95;
                        const topLX = 18,
                            topRX = 82; // narrow top
                        const botLX = 5,
                            botRX = 95; // wide bottom

                        // Trapezoid corners
                        const p1 = api.coord([botLX, topY]); // BL
                        const p2 = api.coord([botRX, topY]); // BR
                        const p3 = api.coord([topRX, botY]); // TR
                        const p4 = api.coord([topLX, botY]); // TL

                        return {
                            type: "group",
                            children: [
                                {
                                    type: "polygon",
                                    shape: { points: [p1, p2, p3, p4] },
                                    style: {
                                        fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0, color: "#F9F9F9" },
                                            { offset: 1, color: "#F9F9F9" }
                                        ]),
                                        stroke: "#494949",
                                        lineWidth: 1.2
                                    }
                                },
                                {
                                    type: "polygon",
                                    shape: {
                                        points: [
                                            [p1[0], p1[1]],
                                            [p2[0], p2[1]],
                                            [p2[0], p2[1] + 8],
                                            [p1[0], p1[1] + 8]
                                        ]
                                    },
                                    style: { fill: "#494949" }
                                }
                            ]
                        };
                    } catch (err) {
                        return { type: "group", children: [] };
                    }
                },
                data: [0]
            };

            // ---- ICON OVERLAY SERIES ----
            const iconSeries = {
                name: "PlayerIcons",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 5,
                zlevel: 1,
                renderItem: (params, api) => {
                    const player = mergedPlayers[params.dataIndex];
                    if (!player || !player.icon) return;
                    const coord = api.coord([player.x, player.y]);
                    const size = 50;
                    const offsetY = -50;
                    const shiftX = -5;
                    return {
                        type: "image",
                        style: {
                            image: player.icon,
                            x: coord[0] - size / 2 + shiftX,
                            y: coord[1] + offsetY,
                            width: size,
                            height: size
                        }
                    };
                },
                data: mergedPlayers
            };

            // ---------------- PLAYERS ----------------
            const graphPlayers = mergedPlayers.map(n => ({
                id: n.id,
                name: n.label,
                value: [n.x, n.y],
                symbol: "circle",
                symbolSize: 80,
                itemStyle: { color: "#494949", borderColor: "#7b8a9a" },
                label: {
                    show: true,
                    position: "inside",
                    offset: [5, 10],
                    rotate: 15,
                    textVerticalAlign: "bottom",
                    textAlign: "center",
                    fontSize: 12,
                    fontFamily: "Franklin Gothic Demi Cond, sans-serif",
                    lineHeight: 12,
                    color: "#D3D3D3",
                    overflow: "break",
                    width: 70,
                    formatter: () => {
                        const words = String(n.label || "").split(" ");
                        const lines = [];
                        let currentLine = "";
                        for (const word of words) {
                            if ((currentLine + word).length <= 12) {
                                currentLine += (currentLine ? " " : "") + word;
                            } else {
                                lines.push(currentLine);
                                currentLine = word;
                            }
                        }
                        if (currentLine) lines.push(currentLine);
                        return lines.join("\n");
                    }
                }
            }));

            // ---- DOTTED LINES WITH OPEN ARROW, USING RAW COORDS ----
            const dottedLinesSeries = {
                name: 'DottedLines',
                type: 'custom',
                coordinateSystem: 'cartesian2d',
                silent: true,
                z: 8,
                zlevel: 2,
                animation: false,            // <--- add this
                progressive: 0,              // <--- prevent progressive rendering
                progressiveThreshold: 0,     // <--- (safety)

                renderItem: (params, api) => {
                    const seg = dottedEdges[params.dataIndex];
                    if (!seg) return { type: 'group', children: [] };

                    // Use the raw coords exactly as given
                    const p1 = api.coord([seg.startX, seg.startY]); // start
                    const p2 = api.coord([seg.endX, seg.endY]);   // end (arrow tip)

                    const dx = p2[0] - p1[0];
                    const dy = p2[1] - p1[1];
                    const len = Math.hypot(dx, dy) || 1;

                    const ux = dx / len;
                    const uy = dy / len;

                    const nx = -uy;
                    const ny = ux;

                    const arrowLength = 10; // px
                    const arrowWidth = 6;  // px

                    // Base of arrow a bit back from tip along the line
                    const baseX = p2[0] - ux * arrowLength;
                    const baseY = p2[1] - uy * arrowLength;

                    const leftWing = [baseX - nx * arrowWidth, baseY - ny * arrowWidth];
                    const rightWing = [baseX + nx * arrowWidth, baseY + ny * arrowWidth];

                    return {
                        type: 'group',
                        children: [
                            // dotted line from start → just before tip (so arrowhead is visible)
                            {
                                type: 'path',
                                shape: {
                                    pathData: `M ${p1[0]} ${p1[1]} L ${baseX} ${baseY}`
                                },
                                style: {
                                    stroke: '#5986d4',
                                    lineWidth: 2,
                                    lineDash: [1, 5],
                                    lineCap: 'round',
                                    lineJoin: 'round',
                                    fill: 'none'
                                }
                            },
                            // open arrowhead at exact endX,endY
                            {
                                type: 'polyline',
                                shape: {
                                    points: [
                                        leftWing,
                                        [p2[0], p2[1]], // tip = endX,endY
                                        rightWing
                                    ]
                                },
                                style: {
                                    stroke: '#5986d4',
                                    lineWidth: 1.8,
                                    fill: 'none',
                                    lineCap: 'round'
                                }
                            }
                        ]
                    };
                },

                data: dottedEdges
            };

            const showNeeds = this.showNeeds;

            // ---- SINGLE TRAFFIC LIGHT (generic, one per dotted line) ----
            const actionTrafficSingleSeries = {
                id: "ActionTrafficSingle",
                name: "ActionTrafficSingle",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                zlevel: 10,
                animation: false,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    // shared offsets
                    let sideOffset = 0;
                    let verticalOffset = -5;
                    if (String(e.id) === "5") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        sideOffset = -18;
                        verticalOffset = 17;
                    } else if (String(e.id) === "11") {
                        sideOffset = -18;
                    }

                    const baseCenter = getDottedMidpoint(api, e, sideOffset, verticalOffset);

                    // normalise signals
                    let signals = Array.isArray(e.signalColor)
                        ? e.signalColor
                        : (e.signalColor ? [e.signalColor] : []);
                    signals = signals
                        .map(s => String(s || "").toLowerCase().trim())
                        .filter(Boolean);

                    if (!signals.length) return { type: "group", children: [] };

                    const sig = signals[0]; // ALWAYS first one

                    const housingW = 20;
                    const housingH = 46;
                    const gray = "#bdc3c7";
                    const gapAboveLine = 12;

                    const lightX = baseCenter[0];
                    const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                    const lightYTop = lightYCenter - housingH / 2;

                    const red = sig === "red" ? "#e74c3c" : gray;
                    const yellow = sig === "yellow" ? "#f1c40f" : gray;
                    const green = sig === "green" ? "#2ecc71" : gray;

                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            ...[0, 1, 2].map(i => ({
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 8 + i * 14, r: 5 },
                                style: { fill: [red, yellow, green][i] }
                            }))
                        ]
                    };
                },
                data: dottedEdges
            };

            // ---- TRAFFIC LIGHTS (per-need when showNeeds, else single above line) ----
            const actionTrafficSeries = {
                name: "ActionTrafficLights",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                zlevel: 10,
                animation: false,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };
                    // --- shared offsets for this dotted line (same as needs) ---
                    let sideOffset = 0;
                    let verticalOffset = -5;
                    if (String(e.id) === "5") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        sideOffset = -18;
                        verticalOffset = 17;
                    } else if (String(e.id) === "11") {
                        sideOffset = -18;
                    }

                    const baseCenter = getDottedMidpoint(api, e, sideOffset, verticalOffset);

                    // --- normalise signalColor to array ---
                    let signals = Array.isArray(e.signalColor)
                        ? e.signalColor
                        : (e.signalColor ? [e.signalColor] : []);
                    signals = signals
                        .map(s => String(s || "").toLowerCase().trim())
                        .filter(Boolean);

                    if (!signals.length) return { type: "group", children: [] };

                    // --- normalise needName to array (for showNeeds mode) ---
                    const rawNeeds = Array.isArray(e.needName)
                        ? e.needName
                        : (e.needName ? [e.needName] : []);
                    const needs = rawNeeds
                        .map(n => String(n || "").trim())
                        .filter(Boolean);

                    const housingW = 20;
                    const housingH = 46;
                    const gray = "#bdc3c7";

                    const gapAboveLine = 12;
                    const gapBetweenBoxAndLights = 10;
                    const interLampGapHoriz = 8;

                    const fontSize = 11;
                    const maxWidth = 70;
                    const paddingX = 5;
                    const lineHeight = fontSize + 2;

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const children = [];

                    // ───────────────── CASE A: showNeeds == false ─────────────────
                    // Always draw ONE traffic light above the line, using the first signal
                    if (!showNeeds) {
                        const sig = signals[0];

                        const lightX = baseCenter[0];
                        const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                        const lightYTop = lightYCenter - housingH / 2;

                        const red = sig === "red" ? "#e74c3c" : gray;
                        const yellow = sig === "yellow" ? "#f1c40f" : gray;
                        const green = sig === "green" ? "#2ecc71" : gray;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            ...[0, 1, 2].map(i => ({
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 8 + i * 14, r: 5 },
                                style: { fill: [red, yellow, green][i] }
                            }))
                        );

                        return { type: "group", children };
                    }

                    // ───────────────── CASE B: showNeeds == true ─────────────────
                    // If we DON’T have multiple needs+signals → fall back to single light above line
                    if (!(needs.length > 1 && signals.length > 1)) {
                        const sig = signals[0];

                        const lightX = baseCenter[0];
                        const lightYCenter = baseCenter[1] - (housingH / 2 + gapAboveLine);
                        const lightYTop = lightYCenter - housingH / 2;

                        const red = sig === "red" ? "#e74c3c" : gray;
                        const yellow = sig === "yellow" ? "#f1c40f" : gray;
                        const green = sig === "green" ? "#2ecc71" : gray;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            ...[0, 1, 2].map(i => ({
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 8 + i * 14, r: 5 },
                                style: { fill: [red, yellow, green][i] }
                            }))
                        );

                        return { type: "group", children };
                    }

                    // ───────────────── CASE C: showNeeds == true AND multiple needs/signals ─────────────────
                    // For each NEED there is a TRAFFIC SIGNAL, aligned vertically with that need,
                    // and placed to the LEFT of the needs box.

                    // 1. Rebuild allLines & track line-span for each need
                    const needBlocks = []; // { startIdx, endIdx }
                    const allLines = [];
                    let currentLineIndex = 0;

                    needs.forEach((needText, idx) => {
                        const wrapped = wrapTextByWidth(needText, maxWidth, ctx);
                        if (!wrapped.length) return;

                        const start = currentLineIndex;
                        wrapped.forEach(l => {
                            allLines.push(l);
                            currentLineIndex++;
                        });

                        const end = currentLineIndex - 1;
                        needBlocks.push({ startIdx: start, endIdx: end });

                        if (idx < needs.length - 1) {
                            // spacer line between needs – must match needsTextSeries
                            allLines.push("");
                            currentLineIndex++;
                        }
                    });

                    if (!allLines.length || !needBlocks.length) {
                        return { type: "group", children: [] };
                    }

                    const totalLines = allLines.length;
                    const totalTextHeight = totalLines * lineHeight;

                    // same center as needs box
                    const center = baseCenter;
                    const rectHeight = totalTextHeight + paddingX * 2;
                    const rectWidth = maxWidth + paddingX * 2;

                    const topTextY = center[1] - totalTextHeight / 2;

                    // X for lamps: LEFT of needs box
                    const lampX =
                        center[0] - rectWidth / 2 - gapBetweenBoxAndLights - housingW / 2;

                    const pairCount = Math.min(needs.length, signals.length);
                    const lampGlobalOffset = 0;        // or small tweak
                    const extraSpacingBetweenLamps = 15; // try 4–10

                    for (let i = 0; i < pairCount; i++) {
                        const block = needBlocks[i];
                        const sig = signals[i];

                        const midLineIndex = (block.startIdx + block.endIdx) / 2;
                        const textCenterY = topTextY + (midLineIndex + 0.5) * lineHeight;

                        //const lightYCenter = textCenterY;
                        const lightYCenter =
                            textCenterY +
                            lampGlobalOffset +
                            (i - (pairCount - 1) / 2) * extraSpacingBetweenLamps;
                        const lightYTop = lightYCenter - housingH / 2;

                        const red = sig === "red" ? "#e74c3c" : gray;
                        const yellow = sig === "yellow" ? "#f1c40f" : gray;
                        const green = sig === "green" ? "#2ecc71" : gray;

                        children.push(
                            {
                                type: "rect",
                                shape: {
                                    x: lampX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            ...[0, 1, 2].map(j => ({
                                type: "circle",
                                shape: { cx: lampX, cy: lightYTop + 8 + j * 14, r: 5 },
                                style: { fill: [red, yellow, green][j] }
                            }))
                        );
                    }

                    return { type: "group", children };
                },
                data: dottedEdges
            };


            // ---- ACTION TEXT SERIES (centered on dotted lines) ----
            const actionTextSeries = {
                name: "ActionLabels",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 100,
                zlevel: 10,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    const act = (e.action || "").trim();
                    if (!act) return { type: "group", children: [] };

                    // same side offsets as traffic, so they move together
                    let sideOffset = 0;
                    let verticalOffset = 0;
                    if (String(e.id) === "5") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        sideOffset = -18;
                        verticalOffset = 22; // move down a bit
                    } else if (String(e.id) === "11") {
                        sideOffset = -18;    // line 8 → a bit to the "right"
                    }

                    const center = getDottedMidpoint(api, e, sideOffset, verticalOffset);

                    const fontSize = 11;
                    const rectWidth = 80;   // fixed width
                    const rectHeight = 30;   // fixed height
                    const paddingX = 5;
                    const paddingY = 3;
                    const maxWidth = rectWidth - paddingX * 2;  // wrap within fixed width

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const words = act.split(" ");
                    const lines = [];
                    let line = "";
                    for (const w of words) {
                        const test = line ? `${line} ${w}` : w;
                        if (ctx.measureText(test).width > maxWidth && line) {
                            lines.push(line);
                            line = w;
                        } else {
                            line = test;
                        }
                    }
                    if (line) lines.push(line);

                    const lineHeight = fontSize + 2;

                    return {
                        type: "group",
                        children: [
                            {
                                // fixed-size rectangle centered on `center`
                                type: "rect",
                                shape: {
                                    x: center[0] - rectWidth / 2,
                                    y: center[1] - rectHeight / 2,
                                    width: rectWidth,
                                    height: rectHeight,
                                    r: 4
                                },
                                style: {
                                    fill: "#fff",
                                    stroke: "#ddd",
                                    shadowColor: "rgba(0,0,0,0.05)",
                                    shadowBlur: 2
                                }
                            },
                            {
                                type: "text",
                                style: {
                                    x: center[0],
                                    y: center[1],                   // vertical center
                                    text: lines.join("\n"),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",    // vertical center alignment
                                    lineHeight,
                                    width: maxWidth,                // wrapping width
                                    fill: "#333",
                                    fontSize: 12,
                                    fontFamily: "Franklin Gothic Book, sans-serif",
                                    fontWeight: "bold"
                                }
                            }
                        ]
                    };
                },
                data: dottedEdges
            };


            // ---- METRICS TEXT SERIES ----
            const metricsTextSeries = {
                name: "MetricsLabels",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 100,
                zlevel: 10,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };
                    //const [src, dst, , , metricName] = e;

                    const metricText = (e.metricName || [])
                        .filter(Boolean)
                        .join("\n")
                        .trim();
                    if (!metricText) return { type: "group", children: [] };

                    let sideOffset = 0;
                    let verticalOffset = 0;
                    if (String(e.id) === "5") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        sideOffset = -18;
                        verticalOffset = 22; // move down a bit
                    } else if (String(e.id) === "11") {
                        sideOffset = -18;    // line 8 → a bit to the "right"
                    }

                    const center = getDottedMidpoint(api, e, sideOffset, verticalOffset);

                    const fontSize = 11;
                    const rectWidth = 100;   // fixed width
                    const rectHeight = 30;   // fixed height
                    const paddingX = 0;
                    const paddingY = 3;
                    const maxWidth = rectWidth - paddingX * 2;  // wrap within fixed width

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const words = metricText.split(" ");
                    const lines = [];
                    let line = "";
                    for (const w of words) {
                        const test = line ? `${line} ${w}` : w;
                        if (ctx.measureText(test).width > maxWidth && line) {
                            lines.push(line);
                            line = w;
                        } else {
                            line = test;
                        }
                    }
                    if (line) lines.push(line);

                    const lineHeight = fontSize + 2;

                    return {
                        type: "group",
                        children: [
                            {
                                // fixed-size rectangle centered on `center`
                                type: "rect",
                                shape: {
                                    x: center[0] - rectWidth / 2,
                                    y: center[1] - rectHeight / 2,
                                    width: rectWidth,
                                    height: rectHeight,
                                    r: 4
                                },
                                style: {
                                    fill: "#F9F9F9",
                                    stroke: "#F9F9F9",
                                }
                            },
                            {
                                type: "text",
                                style: {
                                    x: center[0],
                                    y: center[1],                   // vertical center
                                    text: lines.join("\n"),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",    // vertical center alignment
                                    fontSize,
                                    lineHeight,
                                    width: maxWidth,                // wrapping width
                                    fill: "#3b7d23",
                                    fontWeight: "bold"
                                }
                            }
                        ]
                    };
                },
                data: dottedEdges
            };

            // ---- MOATS TEXT SERIES ----
            const moatsTextSeries = {
                name: "MoatLabels",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 100,
                zlevel: 10,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };
                    //const [src, dst, , , , moatName] = e;

                    const moat = (e.moatName || "").trim();
                    if (!moat) return { type: "group", children: [] };

                    // same side offsets as traffic, so they move together
                    let sideOffset = 0;
                    let verticalOffset = 0;
                    if (String(e.id) === "5") {
                        sideOffset = 18;
                    } else if (String(e.id) === "8") {
                        sideOffset = -18;
                        verticalOffset = 22; // move down a bit
                    } else if (String(e.id) === "11") {
                        sideOffset = -18;    // line 8 → a bit to the "right"
                    }

                    const center = getDottedMidpoint(api, e, sideOffset, verticalOffset);

                    const fontSize = 11;
                    const rectWidth = 80;   // fixed width
                    const rectHeight = 30;   // fixed height
                    const paddingX = 5;
                    const paddingY = 3;
                    const maxWidth = rectWidth - paddingX * 2;  // wrap within fixed width

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const words = moat.split(" ");
                    const lines = [];
                    let line = "";
                    for (const w of words) {
                        const test = line ? `${line} ${w}` : w;
                        if (ctx.measureText(test).width > maxWidth && line) {
                            lines.push(line);
                            line = w;
                        } else {
                            line = test;
                        }
                    }
                    if (line) lines.push(line);

                    const lineHeight = fontSize + 2;

                    // ========= NEW: decide text color from moat_display_options =========
                    let textColor = "#000000"; // default black
                    let bgcolor = "#bf9000"; // default brown

                    const opts = this.moat_display_options || this.moat_display_options;
                    if (opts) {
                        const pioneer = opts["pioneer-moats"] || [];
                        const core  = opts["core-moats"]  || [];

                        if (pioneer.includes(moat)) {
                            bgcolor = "#826300"; // yellow
                            textColor = "#ffffff";
                        } else if (core.includes(moat)) {
                            bgcolor = "#ffe48f"; // dark brown
                        }
                    }

                    return {
                        type: "group",
                        children: [
                            {
                                // fixed-size rectangle centered on `center`
                                type: "rect",
                                shape: {
                                    x: center[0] - rectWidth / 2,
                                    y: center[1] - rectHeight / 2,
                                    width: rectWidth,
                                    height: rectHeight,
                                    r: 4
                                },
                                style: {
                                    fill: bgcolor,
                                    stroke: "none",
                                    shadowColor: "rgba(0,0,0,0.05)",
                                    shadowBlur: 2
                                }
                            },
                            {
                                type: "text",
                                style: {
                                    x: center[0],
                                    y: center[1],                   // vertical center
                                    text: lines.join("\n"),
                                    textAlign: "center",
                                    textVerticalAlign: "middle",    // vertical center alignment
                                    fontSize,
                                    lineHeight,
                                    width: maxWidth,                // wrapping width
                                    fill: textColor,
                                    fontFamily: "Franklin Gothic Demi Cond, sans-serif",
                                }
                            }
                        ]
                    };
                },
                data: dottedEdges
            };


            function wrapTextByWidth(text, maxWidth, ctx) {
                if (!text) return [];

                // Split on spaces and hyphens, but keep the delimiters
                const tokens = String(text).split(/([\s-]+)/); // capturing group keeps separators
                const lines = [];
                let line = "";

                for (const tok of tokens) {
                    const test = line + tok;
                    if (ctx.measureText(test).width > maxWidth && line.trim()) {
                        lines.push(line.trim());
                        line = tok.trimStart();
                    } else {
                        line = test;
                    }
                }
                if (line.trim()) lines.push(line.trim());

                return lines;
            }

            // ---- NEEDS TEXT SERIES ----
            const needsTextSeries = {
                name: "NeedLabels",
                type: "custom",
                coordinateSystem: "cartesian2d",
                z: 100,
                zlevel: 10,
                renderItem: (params, api) => {
                    const e = dottedEdges[params.dataIndex];
                    if (!e) return { type: "group", children: [] };

                    // needName can be array or string
                    const rawNeeds = Array.isArray(e.needName)
                        ? e.needName
                        : (e.needName ? [e.needName] : []);

                    const needs = rawNeeds
                        .map(n => String(n || "").trim())
                        .filter(Boolean);

                    if (!needs.length) return { type: "group", children: [] };

                    // same side offsets as traffic, so they move together
                    let sideOffset = 0;
                    let verticalOffset = 0;
                    if (String(e.id) === "5") {
                        sideOffset = 22;
                    } else if (String(e.id) === "8") {
                        sideOffset = -20;
                        verticalOffset = 22; // move down a bit
                    } else if (String(e.id) === "11") {
                        sideOffset = -18;
                    }

                    const fontSize = 11;
                    const paddingX = 5;
                    const paddingY = 3;
                    const lineHeight = fontSize + 2;
                    const maxWidth = 70;

                    const ctx =
                        this._measureCtx ||
                        document.createElement("canvas").getContext("2d");
                    ctx.font = `${fontSize}px sans-serif`;

                    const children = [];

                    // ===== CASE 1: exactly TWO needs → one above, one below dotted line =====
                    if (needs.length === 2) {
                        const verticalDelta = 14; // distance above / below line

                        needs.forEach((needText, idx) => {
                            const localVerticalOffset =
                                idx === 0
                                    ? verticalOffset - verticalDelta   // above
                                    : verticalOffset + verticalDelta;  // below

                            const center = getDottedMidpoint(api, e, sideOffset, localVerticalOffset);

                            const lines = wrapTextByWidth(needText, maxWidth, ctx);
                            if (!lines.length) return;

                            let maxLineWidth = 0;
                            lines.forEach(line => {
                                const w = ctx.measureText(line).width;
                                if (w > maxLineWidth) maxLineWidth = w;
                            });

                            const rectWidth = maxLineWidth + paddingX * 2;
                            const rectHeight = lines.length * lineHeight + paddingY * 2;

                            children.push(
                                {
                                    type: "rect",
                                    shape: {
                                        x: center[0] - rectWidth / 2,
                                        y: center[1] - rectHeight / 2,
                                        width: rectWidth,
                                        height: rectHeight,
                                        r: 4
                                    },
                                    style: { fill: "#F9F9F9" }
                                },
                                {
                                    type: "text",
                                    style: {
                                        x: center[0],
                                        y: center[1],
                                        text: lines.join("\n"),
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        lineHeight,
                                        width: rectWidth - paddingX * 2,
                                        fill: "#5986d4",
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                    }
                                }
                            );
                        });

                        return { type: "group", children };
                    }

                    // ===== CASE 2: 1 or >2 needs → single box, each need on its own block, wrapped =====
                    const allLines = [];
                    needs.forEach((needText, idx) => {
                        const wrapped = wrapTextByWidth(needText, maxWidth, ctx);
                        if (!wrapped.length) return;
                        wrapped.forEach(l => allLines.push(l));
                        // optional: add a small spacer line between different needs
                        if (idx < needs.length - 1) {
                            allLines.push(""); // comment out this line if no extra space required
                        }
                    });

                    if (!allLines.length) return { type: "group", children: [] };

                    let maxLineWidth = 0;
                    allLines.forEach(line => {
                        const w = ctx.measureText(line).width;
                        if (w > maxLineWidth) maxLineWidth = w;
                    });

                    const rectWidth = maxLineWidth + paddingX * 2;
                    const rectHeight = allLines.length * lineHeight + paddingY * 2;

                    const center = getDottedMidpoint(api, e, sideOffset, verticalOffset);

                    children.push(
                        {
                            type: "rect",
                            shape: {
                                x: center[0] - rectWidth / 2,
                                y: center[1] - rectHeight / 2,
                                width: rectWidth,
                                height: rectHeight,
                                r: 4
                            },
                            style: { fill: "#F9F9F9" }
                        },
                        {
                            type: "text",
                            style: {
                                x: center[0],
                                y: center[1],
                                text: allLines.join("\n"),
                                textAlign: "center",
                                textVerticalAlign: "middle",
                                fontSize: 12,
                                lineHeight,
                                width: rectWidth - paddingX * 2,
                                fill: "#5986d4",
                                fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                            }
                        }
                    );

                    return { type: "group", children };
                },
                data: dottedEdges
            };

            // graph series
            const graphSeries = {
                id: 'PlayersGraph',
                type: 'graph',
                name: 'Players',
                coordinateSystem: 'cartesian2d',
                // keep positions fixed by coords
                nodeScaleRatio: 0,
                roam: false,
                z: 10,                       // nodes above edges
                data: graphPlayers,          // has id + x,y
                links: [],
                label: { show: true }        // node labels
            };

            // ---- Dotted rounded border along the trapezoid ----
            const dottedRoundedBorder = {
                name: 'TrapezoidDottedRounded',
                type: 'custom',
                coordinateSystem: 'cartesian2d',
                silent: true,
                z: 20,
                zlevel: 3,
                renderItem: (params, api) => {
                    try {
                        if (!api || typeof api.coord !== 'function') {
                            return { type: 'group', children: [] };
                        }

                        // SAME geometry as basePlate (internal to the trapezoid)
                        const topY = 28, botY = 93;
                        const topLX = 18, topRX = 82;
                        const botLX = 8, botRX = 92;

                        // Polygon in order: BL → BR → TR → TL
                        const BL = api.coord([botLX, topY]);
                        const BR = api.coord([botRX, topY]);
                        const TR = api.coord([topRX, botY]);
                        const TL = api.coord([topLX, botY]);

                        const dist = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
                        const moveTowards = (from, to, d) => {
                            const dx = to[0] - from[0];
                            const dy = to[1] - from[1];
                            const L = Math.hypot(dx, dy) || 1;
                            return [
                                from[0] + (dx / L) * d,
                                from[1] + (dy / L) * d
                            ];
                        };

                        // Edge lengths
                        const lenBL_BR = dist(BL, BR);
                        const lenBR_TR = dist(BR, TR);
                        const lenTR_TL = dist(TR, TL);
                        const lenTL_BL = dist(TL, BL);

                        // Hard upper bound
                        const R = 999;

                        // Absolute radii per corner (in px) - INCREASED FOR BIGGER CURVATURE
                        const bottomCornerRadiusPx = 350;  // Very big curves
                        const topCornerRadiusPx = 160;  // Larger top curves

                        // Clamp each corner radius by its two adjacent edges (<= half each edge)
                        const rBL = Math.min(
                            R,
                            bottomCornerRadiusPx,
                            lenBL_BR / 2,
                            lenTL_BL / 2
                        );
                        const rBR = Math.min(
                            R,
                            bottomCornerRadiusPx,
                            lenBL_BR / 2,
                            lenBR_TR / 2
                        );
                        const rTR = Math.min(
                            R,
                            topCornerRadiusPx,
                            lenBR_TR / 2,
                            lenTR_TL / 2
                        );
                        const rTL = Math.min(
                            R,
                            topCornerRadiusPx,
                            lenTR_TL / 2,
                            lenTL_BL / 2
                        );

                        // Trim points along edges for each corner
                        const BL_r = moveTowards(BL, BR, rBL);
                        const BL_u = moveTowards(BL, TL, rBL);

                        const BR_l = moveTowards(BR, BL, rBR);
                        const BR_u = moveTowards(BR, TR, rBR);

                        const TR_d = moveTowards(TR, BR, rTR);
                        const TR_l = moveTowards(TR, TL, rTR);

                        const TL_r = moveTowards(TL, TR, rTL);
                        const TL_d = moveTowards(TL, BL, rTL);

                        // Build path: straight segments + corner arcs (using Quadratic Bezier Curves 'Q')
                        const dPath = [
                            `M ${BL_r[0]} ${BL_r[1]}`,                          // start on bottom edge
                            `L ${BR_l[0]} ${BR_l[1]}`,                          // bottom BL→BR
                            `Q ${BR[0]} ${BR[1]} ${BR_u[0]} ${BR_u[1]}`,        // bottom-right corner
                            `L ${TR_d[0]} ${TR_d[1]}`,                          // right BR→TR
                            `Q ${TR[0]} ${TR[1]} ${TR_l[0]} ${TR_l[1]}`,        // top-right corner
                            `L ${TL_r[0]} ${TL_r[1]}`,                          // top TR→TL
                            `Q ${TL[0]} ${TL[1]} ${TL_d[0]} ${TL_d[1]}`,        // top-left corner
                            `L ${BL_u[0]} ${BL_u[1]}`,                          // left TL→BL
                            `Q ${BL[0]} ${BL[1]} ${BL_r[0]} ${BL_r[1]}`,        // bottom-left corner
                            'Z'
                        ].join(' ');

                        return {
                            type: 'path',
                            shape: { pathData: dPath },
                            style: {
                                fill: 'none',
                                stroke: '#5986d4',
                                lineWidth: 2,
                                lineDash: [1, 5],
                                lineJoin: 'round',
                                lineCap: 'round'
                            }
                        };
                    } catch (err) {
                        return { type: 'group', children: [] };
                    }
                },
                data: [0]
            };

            // bottom blocks (unchanged)
            const bottomBlocksSeries = {
                name: "BottomBlocks",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 30,
                zlevel: 5,
                animation: false,            // <--- add this
                progressive: 0,              // <--- prevent progressive rendering
                progressiveThreshold: 0,     // <--- (safety)
                renderItem: (params, api) => {
                    const bottomLabels = this.emotionalNeedsList
                        .map(item => item.needLabel)
                        .filter(Boolean);
                    if (!bottomLabels[params.dataIndex]) return { type: "group", children: [] };

                    const n = bottomLabels.length;

                    const topY = 28,
                        botY = 93;
                    const topLX = 19,
                        topRX = 81;
                    const botLX = 6,
                        botRX = 94;

                    const BL = api.coord([botLX, topY]);
                    const BR = api.coord([botRX, topY]);
                    const TR = api.coord([topRX, botY]);
                    const TL = api.coord([topLX, botY]);

                    const dist = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
                    const moveTowards = (from, to, d) => {
                        const dx = to[0] - from[0];
                        const dy = to[1] - from[1];
                        const L = Math.hypot(dx, dy) || 1;
                        return [from[0] + (dx / L) * d, from[1] + (dy / L) * d];
                    };

                    const R = 100;
                    const lenBL_BR = dist(BL, BR);
                    const rBL = Math.min(R, lenBL_BR * 0.45);

                    const BL_r = moveTowards(BL, BR, rBL);
                    const BR_l = moveTowards(BR, BL, rBL);

                    const spreadFactor = 0.4;
                    const startOffset = (1 - spreadFactor) / 2;
                    const t = startOffset + (params.dataIndex / (n - 1)) * spreadFactor;

                    const centerX = BL_r[0] + (BR_l[0] - BL_r[0]) * t;
                    const centerY = BL_r[1] + (BR_l[1] - BL_r[1]) * t;

                    const rectW = 60,
                        rectH = 25,
                        fontSize = 9;

                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: centerX - rectW / 2,
                                    y: centerY - rectH / 2,
                                    width: rectW,
                                    height: rectH,
                                    r: 0
                                },
                                style: {
                                    fill: "#5986d4",
                                    stroke: "#5986d4",
                                    lineWidth: 1.5
                                }
                            },
                            {
                                type: "text",
                                style: {
                                    x: centerX,
                                    y: centerY,
                                    text: bottomLabels[params.dataIndex],
                                    textAlign: "center",
                                    textVerticalAlign: "middle",
                                    fontSize: 12,
                                    fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                    fill: "#fff"
                                }
                            }
                        ]
                    };
                },
                data: (this.emotionalNeedsList || []).map((_, i) => i)
            };

            const bottomBlocksTrafficSeries = {
                name: "BottomBlocksTraffic",
                type: "custom",
                coordinateSystem: "cartesian2d",
                silent: true,
                z: 101,
                zlevel: 10,
                renderItem: (params, api) => {
                    const bottomTrafficSignals = this.emotionalNeedsList
                        .map(item => item.signalColor)
                        .filter(Boolean);
                    const idx = params.dataIndex;
                    if (!bottomTrafficSignals[idx]) return { type: "group", children: [] };

                    const item = bottomTrafficSignals[idx];
                    const n = bottomTrafficSignals.length;
                    const topY = 27,
                        botY = 93;
                    const topLX = 19,
                        topRX = 81;
                    const botLX = 6,
                        botRX = 94;

                    const BL = api.coord([botLX, topY]);
                    const BR = api.coord([botRX, topY]);
                    const TR = api.coord([topRX, botY]);
                    const TL = api.coord([topLX, botY]);

                    const dist = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]) || 1;
                    const moveTowards = (from, to, d) => {
                        const dx = to[0] - from[0];
                        const dy = to[1] - from[1];
                        const L = Math.hypot(dx, dy) || 1;
                        return [from[0] + (dx / L) * d, from[1] + (dy / L) * d];
                    };

                    const R = 100;
                    const lenBL_BR = dist(BL, BR);
                    const rBL = Math.min(R, lenBL_BR * 0.45);

                    const BL_r = moveTowards(BL, BR, rBL);
                    const BR_l = moveTowards(BR, BL, rBL);

                    const spreadFactor = 0.4;
                    const startOffset = (1 - spreadFactor) / 2;
                    const t = startOffset + (idx / (n - 1)) * spreadFactor;

                    const centerX = BL_r[0] + (BR_l[0] - BL_r[0]) * t;
                    const centerY = BL_r[1] + (BR_l[1] - BL_r[1]) * t;

                    const rectH = 25;
                    const gap = 10;

                    const housingW = 20,
                        housingH = 46;
                    const lightX = centerX;
                    const lightYTop = centerY + rectH / 2 + gap;

                    const gray = "#bdc3c7";

                    // derive traffic signal color
                    const red = item === "red" ? "#e74c3c" : gray;
                    const yellow = item === "yellow" ? "#f1c40f" : gray;
                    const green = item === "green" ? "#2ecc71" : gray;

                    return {
                        type: "group",
                        children: [
                            {
                                type: "rect",
                                shape: {
                                    x: lightX - housingW / 2,
                                    y: lightYTop,
                                    width: housingW,
                                    height: housingH,
                                    r: 4
                                },
                                style: { fill: "#2c3e50" }
                            },
                            {
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 8, r: 5 },
                                style: { fill: red }
                            },
                            {
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 22, r: 5 },
                                style: { fill: yellow }
                            },
                            {
                                type: "circle",
                                shape: { cx: lightX, cy: lightYTop + 36, r: 5 },
                                style: { fill: green }
                            }
                        ]
                    };
                },
                data: (this.emotionalNeedsList || []).map((_, i) => i)
            };

            // --- Legends (right side of trapezium) ---
            const legendYCenter = 200;
            const legendX = 1020;

            const legendGraphics = [
                {
                    type: "group",
                    silent: true,
                    z: 1000,
                    children: [
                        {
                            type: "circle",
                            shape: { cx: legendX, cy: legendYCenter - 40, r: 27 },
                            style: { fill: "#494949", stroke: "#7b8a9a", lineWidth: 1.5 }
                        },
                        {
                            type: "text",
                            rotation: (15 * Math.PI) / 180,
                            origin: [legendX, legendYCenter - 40],
                            style: {
                                x: legendX,
                                y: legendYCenter - 40,
                                text: "Value\nPlayers",
                                fill: "#D3D3D3",
                                fontSize: 12,
                                fontFamily: "Franklin Gothic Demi Cond, sans-serif",
                                textAlign: "center",
                                textVerticalAlign: "middle"
                            }
                        }
                    ]
                },
                ...(this.showActions
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "rect",
                                    shape: {
                                        x: legendX - 38,
                                        y: legendYCenter + 10,
                                        width: 80,
                                        height: 30,
                                        r: 4
                                    },
                                    style: {
                                        fill: "#fff",
                                        stroke: "#ddd",
                                        shadowColor: "rgba(0,0,0,0.05)",
                                        shadowBlur: 2
                                    }
                                },
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 25,
                                        text: "Actions",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fill: "#333",
                                        fontSize: 12,
                                        fontFamily: "Franklin Gothic Book, sans-serif",
                                        fontWeight: "bold"
                                    }
                                }
                            ]
                        }
                    ]
                    : []),
                ...(this.showMetrics
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 24,
                                        text: "Metrics",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                        fill: "#3b7d23"
                                    }
                                }
                            ]
                        }
                    ]
                    : []),
                ...(this.showMoats
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "rect",
                                    shape: {
                                        x: legendX - 38,
                                        y: legendYCenter + 10,
                                        width: 80,
                                        height: 30,
                                        r: 4
                                    },
                                    style: {
                                        fill: "#bf9000",
                                        stroke: "none",
                                        shadowColor: "rgba(0,0,0,0.05)",
                                        shadowBlur: 2
                                    }
                                },
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 25,
                                        text: "Moats",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        fill: "#000000",
                                        fontFamily: "Franklin Gothic Demi Cond, sans-serif",
                                    }
                                }
                            ]
                        }
                    ]
                    : []),
                ...(this.showNeeds
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 10,
                                        text: "Functional Needs",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                        fill: "#5986d4"
                                    }
                                }
                            ]
                        }
                    ]
                    : []),
                ...(this.showNeeds
                    ? [
                        {
                            type: "group",
                            silent: true,
                            z: 1000,
                            children: [
                                {
                                    type: "rect",
                                    shape: {
                                        x: legendX - 38,
                                        y: legendYCenter + 30,
                                        width: 75,
                                        height: 25,
                                        r: 0
                                    },
                                    style: {
                                        fill: "#5986d4",
                                        stroke: "#5986d4",
                                        shadowColor: "rgba(0,0,0,0.05)",
                                        shadowBlur: 2
                                    }
                                },
                                {
                                    type: "text",
                                    style: {
                                        x: legendX,
                                        y: legendYCenter + 42,
                                        text: "Emotional Needs",
                                        textAlign: "center",
                                        textVerticalAlign: "middle",
                                        fontSize: 12,
                                        fill: "#fff",
                                        fontFamily: "Franklin Gothic Medium Cond, sans-serif",
                                    }
                                }
                            ]
                        }
                    ]
                    : [])
            ];

            const edgeTrafficSeries = showNeeds
                ? actionTrafficSeries
                : actionTrafficSingleSeries;

            return {
                animation: false,
                animationDuration: 0,
                animationDurationUpdate: 0,
                animationEasing: "linear",

                grid: { left: 20, right: 20, top: 0, bottom: 0, containLabel: false },
                xAxis: { type: "value", min: 0, max: 100, show: false },
                yAxis: { type: "value", min: 0, max: 100, show: false },
                tooltip: {
                    trigger: "item",
                    formatter: p => {
                        if (p.seriesName === "Players") {
                            const n = this.playerNodes.find(x => x.id === p.data.id);
                            return `${n.label}`;
                        }
                        return "";
                    }
                },
                series: [
                    basePlate,
                    dottedLinesSeries,      // NEW dotted lines
                    iconSeries,
                    graphSeries,

                    ...(this.showActions ? [actionTextSeries] : []),
                    ...(this.showMetrics ? [metricsTextSeries] : []),
                    ...(this.showMoats ? [moatsTextSeries] : []),
                    ...(this.showNeeds ? [needsTextSeries, dottedRoundedBorder, bottomBlocksSeries] : []),
                    ...(this.showTraffic
                        ? [edgeTrafficSeries, bottomBlocksSeries, bottomBlocksTrafficSeries]
                        : [])
                ],
                graphic: legendGraphics
            };
        },

        render() {
            if (!this.chart) return;
            const option = this.buildOption();
            // Make absolutely sure no animations & no merging of old series
            option.animation = false;
            option.animationDuration = 0;
            option.animationDurationUpdate = 0;
            this.chart.setOption(option, { notMerge: true, lazyUpdate: false });
        }
    },
};
</script>
<style scoped>
.chart {
    width: 100%;
    height: 600px;
}
</style>